import { createBrowserRouter } from 'react-router-dom';

import { AdminLayout } from '@/layouts/admin-layout';
import { AuthLayout } from '@/layouts/auth-layout';
import { ProtectedRoute } from '@/modules/auth/components/protected-route';
import { RequireRole } from '@/modules/auth/components/require-role';
import { LoginPage } from '@/modules/auth/pages/login-page';
import { DashboardPage } from '@/modules/dashboard/pages/dashboard-page';
import { ProjectFormPage } from '@/modules/projects/pages/project-form-page';
import { ProjectsListPage } from '@/modules/projects/pages/projects-list-page';
import { AmbientesPage } from '@/modules/site-content/pages/ambientes-page';
import { AteliePage } from '@/modules/site-content/pages/atelie-page';
import { ContatoPage } from '@/modules/site-content/pages/contato-page';
import { DepoimentoPage } from '@/modules/site-content/pages/depoimento-page';
import { HeroPage } from '@/modules/site-content/pages/hero-page';
import { ProcessoPage } from '@/modules/site-content/pages/processo-page';
import { ShowroomPage } from '@/modules/site-content/pages/showroom-page';
import { UserFormPage } from '@/modules/users/pages/user-form-page';
import { UsersListPage } from '@/modules/users/pages/users-list-page';

/**
 * Rotas do painel, separadas em duas cascas: `AuthLayout` para o que é público
 * e `AdminLayout` para o que exige sessão.
 *
 * `ProtectedRoute` envolve o `AdminLayout`, e não cada rota: assim um módulo
 * novo do CMS nasce protegido por estar no lugar certo, sem ninguém precisar
 * lembrar de adicionar o guarda.
 *
 * Os módulos do CMS (hero, atelier, environments, projects, backstage, process,
 * testimonials, showroom, leads, settings, seo, users) registram as suas rotas
 * como filhas de `AdminLayout`.
 */
export const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: [{ path: '/login', element: <LoginPage /> }],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <AdminLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'projetos', element: <ProjectsListPage /> },
          { path: 'projetos/novo', element: <ProjectFormPage /> },
          { path: 'projetos/:id', element: <ProjectFormPage /> },
          { path: 'ambientes', element: <AmbientesPage /> },
          { path: 'atelie', element: <AteliePage /> },
          { path: 'banner', element: <HeroPage /> },
          { path: 'depoimento', element: <DepoimentoPage /> },
          { path: 'empresa', element: <ContatoPage /> },
          { path: 'processo', element: <ProcessoPage /> },
          { path: 'showroom', element: <ShowroomPage /> },
          {
            // Gerenciar contas é exclusivo de ADMIN, e a API recusa EDITOR até
            // na leitura. A barreira aqui evita que a pessoa descubra isso por
            // um erro depois de clicar.
            element: <RequireRole papeis={['ADMIN']} />,
            children: [
              { path: 'usuarios', element: <UsersListPage /> },
              { path: 'usuarios/novo', element: <UserFormPage /> },
              { path: 'usuarios/:id', element: <UserFormPage /> },
            ],
          },
        ],
      },
    ],
  },
]);
